import { useAsyncActionHandler, useSelectedNetwork } from "@umami/state";

import { saplingWorkerService } from "@/services/saplingWorkerService";

type UsePrepareUnshieldProps = {
  toAddress: string;
  amount: number;
};

export const usePrepareUnshield = ({ toAddress, amount }: UsePrepareUnshieldProps) => {
  const { isLoading, handleAsyncAction } = useAsyncActionHandler();
  const { saplingContractAddress: contractAddress = "", rpcUrl } = useSelectedNetwork();

  const prepareUnshield = (mnemonic: string) =>
    handleAsyncAction(async () => {
      const unshieldedTx = await saplingWorkerService.prepareUnshieldedTransaction({
        mnemonic,
        contractAddress,
        rpcUrl,
        transaction: {
          to: toAddress,
          amount,
          mutez: false,
        },
      });

      return unshieldedTx;
    });

  return {
    prepareUnshield,
    isLoading,
  };
};
